import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";

export const INSPECTION_PAGES = {
  GENERAL: "General",
  SCHEDULE: "Schedule",
  RATINGS: "Ratings",
  APPROACH: "Approach",
  DECK: "Deck",
  JOINTS: "Joints",
  SUPERSTRUCTURE: "Superstructure",
  BEARINGS: "Bearings",
  SUBSTRUCTURE: "Substructure",
  CULVERT: "Culvert",
  WATERWAY: "Waterway",
  LOAD_RATING: "Load Rating",
  NSTM_FATIGUE: "NSTM/Fatigue",
  ELEMENTS: "Elements",
  FEATURES: "Features",
  MAINTENANCE_ITEMS: "Maintenance",
  MAINTENANCE_INCLUDE: "Include Completed Maintenance Candidates",
  NOTES: "Notes",
  SIGNS_AND_LIGHTS: "Signs & Lights",
  WALLS: "Walls",
  TUNNELS: "Tunnels",
  EDOCS: "E-Docs",
};
export const BRIDGE_PAGES = [
  INSPECTION_PAGES.GENERAL,
  INSPECTION_PAGES.SCHEDULE,
  INSPECTION_PAGES.RATINGS,
  INSPECTION_PAGES.APPROACH,
  INSPECTION_PAGES.DECK,
  INSPECTION_PAGES.JOINTS,
  INSPECTION_PAGES.SUPERSTRUCTURE,
  INSPECTION_PAGES.BEARINGS,
  INSPECTION_PAGES.SUBSTRUCTURE,
  INSPECTION_PAGES.CULVERT,
  INSPECTION_PAGES.WATERWAY,
  INSPECTION_PAGES.LOAD_RATING,
  INSPECTION_PAGES.NSTM_FATIGUE,
  INSPECTION_PAGES.ELEMENTS,
  INSPECTION_PAGES.FEATURES,
  INSPECTION_PAGES.MAINTENANCE_ITEMS,
  INSPECTION_PAGES.NOTES,
  INSPECTION_PAGES.EDOCS,
];
export const SIGN_PAGES = [
  INSPECTION_PAGES.GENERAL,
  INSPECTION_PAGES.SCHEDULE,
  INSPECTION_PAGES.RATINGS,
  INSPECTION_PAGES.APPROACH,
  INSPECTION_PAGES.FEATURES,
  INSPECTION_PAGES.MAINTENANCE_ITEMS,
  INSPECTION_PAGES.NOTES,
  INSPECTION_PAGES.SIGNS_AND_LIGHTS,
  INSPECTION_PAGES.EDOCS,
];
export const WALL_PAGES = [
  INSPECTION_PAGES.GENERAL,
  INSPECTION_PAGES.SCHEDULE,
  INSPECTION_PAGES.RATINGS,
  INSPECTION_PAGES.APPROACH,
  INSPECTION_PAGES.FEATURES,
  INSPECTION_PAGES.MAINTENANCE_ITEMS,
  INSPECTION_PAGES.NOTES,
  INSPECTION_PAGES.WALLS,
  INSPECTION_PAGES.EDOCS,
];
export const TUNNEL_PAGES = [
  INSPECTION_PAGES.GENERAL,
  INSPECTION_PAGES.SCHEDULE,
  INSPECTION_PAGES.RATINGS,
  INSPECTION_PAGES.APPROACH,
  INSPECTION_PAGES.LOAD_RATING,
  INSPECTION_PAGES.ELEMENTS,
  INSPECTION_PAGES.FEATURES,
  INSPECTION_PAGES.MAINTENANCE_ITEMS,
  INSPECTION_PAGES.NOTES,
  INSPECTION_PAGES.TUNNELS,
  INSPECTION_PAGES.EDOCS,
];

export const EDOCS_PAGES = [INSPECTION_PAGES.EDOCS];

//Streambed materials
export const STREAM_BED_MATERIALS = new Map([
  ["A3", 1],
  ["A4", 2],
  ["R4", 3],
  ["C7", 4],
  ["C8", 5],
  ["A5", 6],
  ["A6", 7],
  ["R7", 8],
  ["R8", 9],
  ["R9", 10],
  ["D9", 11],
]);

export const INSPECTION_COMMENTS = {
  APPROACH_ALIGNMENT: "1",
  APPROACH_DRAINAGE: "3",
  APPROACH_PAVEMENT: "2",
  APPROACH_SHOULDERS: "4",
  APPROACH_SLAB: "5",
  BACKWALL: "20",
  BANKS: "46",
  BEARING_OVERALL_COMMENTS: "34",
  BRIDGE_RAILING: "7",
  BRIDGE_SEATS: "21",
  BRIDGE_SEATS_PIER: "41",
  BUMP_AT_BRIDGE_OBJECT: "69",
  CHANNEL: "45",
  CHANNEL_PROTECTION: "80",
  CHEEKWALLS: "22",
  CHEEKWALLS_PIER: "42",
  COLUMNS_STEMS_PIER: "43",
  COMBUSTIBLE_MATERIAL: "38",
  COMBUSTIBLE_MATERIAL_PIER: "39",
  COMBUSTIBLE_MATERIALS_COMMENTS: "74",
  COMBUSTIBLE_MATERIALS_UNDER_BRIDGE: "82",
  CONDITION_SUMMARY_PIER: "40",
  CULVERT: "71",
  CULVERT_BARREL: "60",
  CULVERT_DEBRIS: "65",
  CULVERT_FLOOR_PAVE: "61",
  CULVERT_FOOTING: "78",
  CULVERT_HEADWALL: "62",
  CULVERT_SETTLEMENT: "64",
  CULVERT_TOP_SLAB: "59",
  CULVERT_WINGS: "63",
  DEBRIS_VEGITATION: "48",
  DECK_DRAINAGE: "13",
  DECK_TOP_WEARING_SURFACE: "35",
  DECK_UNDERSIDE: "36",
  DRIFT_OTHER: "51",
  EMBANK_SLOPE_WALL: "28",
  EMBANKMENT_STREAMBED_CONTROLS: "50",
  FOOTING: "25",
  FUTURE_INSPECTION_LIMITED_SCOPE: "481",
  GUIDE_RAIL: "9",
  HIGH_WATER_MARK: "52",
  INACCESSIBLE_AREA: "75",
  INTERIOR_BEAM_GIRDER: "53",
  JOINTS_TINSP_COMMENTS: "70",
  LOAD_RATING_POSTING_RECOMMENDED_SUMMARY: "76",
  LOAD_RATING_REVIEW: "79",
  OVERALL: "109",
  OVERALL_DECK_COMMENTS: "12",
  OVERALL_WALL: "138",
  OVERALL_WEARING_SURFACE_COMMENTS: "14",
  PAINT_BEARINGS: "57",
  PAINT_FASCIAS: "54",
  PAINT_OTHER: "58",
  PAINT_OVERALL: "77",
  PAINT_SPLASH_ZONE: "55",
  PAINT_TRUSS: "56",
  PAVEMENT_RELIEF_JOINTS: "6",
  PILES: "26",
  RAIL_END: "10",
  REVIEW_RECOMMENDED_DUE_TO_COMMENTS: "67",
  RIVER_CONTROL_DEVICES: "49",
  SETTLEMENT: "27",
  SETTLEMENT_PIER: "44",
  SIGN_ACCESS_METH: "103",
  SIGN_ASSET_TAGS: "110",
  SIGN_COLUMN: "101",
  SIGN_COLUMN_BASE: "100",
  SIGN_FRAMEWORK: "107",
  SIGN_GUIDE_RAIL: "102",
  SIGN_LIGHTS: "104",
  SIGN_SIGN: "106",
  SIGN_SURFACE_PAINT: "108",
  STEM: "23",
  STREAMBED_MOVEMENTS: "47",
  SUBMISSION_VALIDATION_COMMENT: "478",
  ACCEPTANCE_VALIDATION_COMMENT: "479",
  SUBSTRUCTURE: "19",
  SUPER_DIAPHRAGMS: "16",
  SUPER_DRAINAGE: "18",
  SUPER_FLOORBEAMS: "31",
  SUPER_GIRDERS: "30",
  SUPER_PORTALS: "17",
  SUPER_STRINGERS: "32",
  SUPER_TRUSS_MEMBERS: "33",
  SUPERSTRUCTURE: "15",
  TRANSITION: "8",
  UTILITY_REPAIR: "81",
  WALL: "132",
  WALL_ANCHORAGE: "130",
  WALL_BACKFLIP_DAMPING: "131",
  WALL_DRAINAGE: "29",
  WALL_FOUNDATION: "134",
  WALL_PAGE_DRAINAGE: "133",
  WALL_PANEL: "137",
  WALL_PARAPETS: "135",
  WALL_POST: "136",
  WATERWAY_ADEQUACY: "66",
  WINGS: "24",
};

export const SUB_STRUCTURE_UNIT_KEY = {
  NEAR_ABUTMENT: "NAB",
  FAR_ABUTMENT: "FAB",
};

export const STRUCTURE_UNIT_TYPE = {
  APRAS_SPAN: "X",
  ABUTMENT: "B",
  PIER: "P",
  MAIN: "M",
  APPROACH: "A",
  CULVERT: "C",
};
export const DOWNLOAD_PROGRESS = {
  START: "start",
  END: "end",
  SUCCESS: "success",
  FAIL: "fail",
};
export const EDOC_CATEGORY = {
  INVENTORY: "Inventory",
  INSPECTION: "Inspection",
  OTHER: "Other",
};
export const CHECKBOX_VALUE = {
  CHECKED: "1",
  UNCHECKED: "0",
};
export const INSPECTION_TYPE_PERFORMED = {
  INITIAL: "1",
  ROUTINE: "2",
  UNDERWATER: "3",
  NSTM: "4",
  DAMAGE: "5",
  IN_DEPTH: "6",
  SPECIAL: "7",
  SERVICE: "8",
  SCOUR_MONITORING: "9",
  PROBLEM_AREA: "P",
  ELEMENT: "E",
  QA: "Q",
};
export const STATUSES_CAN_SUBMIT = [
  INSPECTION_STATUSES.READY_TO_SUBMIT,
  INSPECTION_STATUSES.NEW,
  INSPECTION_STATUSES.SUBMITTED,
  INSPECTION_STATUSES.VALIDATION_ERROR,
];

export const DISABLE_REPORT_SUBMIT = [INSPECTION_STATUSES.NEW, INSPECTION_STATUSES.VALIDATION_ERROR];
